import { render, staticRenderFns } from "./workListItem.vue?vue&type=template&id=b120e9e6&scoped=true"
import script from "./workListItem.vue?vue&type=script&lang=js"
export * from "./workListItem.vue?vue&type=script&lang=js"
import style0 from "./workListItem.vue?vue&type=style&index=0&id=b120e9e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b120e9e6",
  null
  
)

export default component.exports